import "../scss/main.scss";

(function ($) {
  $(document).ready(function () {
    theme.init();
  });

  var theme = {
    init: function () {
      this.headerFunctions();
      this.variations();
      this.sizeTable();
      this.ajaxSearch();
      this.productsFunctions();
      this.infiniteScroll();
      if ($(window).width() > 768) {
        this.addToCartAjax();
      }
      $("#tabs").tabs();
    },

    headerFunctions: function () {
      // mobile menu toggle
      $(".toggle-nav").click(function (e) {
        e.preventDefault();
        $("body").toggleClass("fixed");
        $(" #mobile-menu").toggleClass("opened");
      });

      $('<span class="toggle"></span>').insertAfter('#mobile-menu .menu li.has-submenu > a');
      $("#mobile-menu .menu li.has-submenu .toggle").on("click", function () {
          $(this).toggleClass("opened");
          $(this).parent().find("> .sub-menu").slideToggle();
        }
      );

      $(".mobile-menu .menu li.has-submenu").append(
        '<span class="toggle"></span>'
      );

      $(".mobile-menu .menu li.has-submenu .toggle").on("click", function () {
          $(this).toggleClass("opened");
          $(this).parent().find(".sub-menu").slideToggle();
        }
      );

      $(".mobile-menu .inner a.close").on("click", function (e) {
        e.preventDefault();
        $(".mobile-menu .inner").removeClass("opened");
        $(".mobile-menu").fadeOut();
        $("body").removeClass("fixed");
      });

      // sticky header
      $(window).scroll(function () {
        var scroll = $(window).scrollTop();

        if (scroll >= 300) $("header.navbar").addClass("fixed");
        else $("header.navbar").removeClass("fixed");
      });

      // search focus
      if ($(window).width() > 560) {
        $("input.search-field").focus(function () {
          $("#searchform").css("margin-left", "-120px");
        });
      } else {
        $("input.search-field").focus(function () {
          $("#searchform").css({
            "margin-left": "calc(-1*(100vw - 120px))",
            width: "calc(100vw - 200px)",
          });
        });
        $("input.search-field").focusout(function () {
          $("#searchform").css({ "margin-left": "0", width: "40px" });
        });
      }
    },

    variations: function () {
      $(document).on("change", ".variation-radios input", function () {
        $(".variation-radios input:checked").each(function (index, element) {
          var $el = $(element);
          var thisName = $el.attr("name");
          var thisVal = $el.attr("value");
          $('select[name="' + thisName + '"]')
            .val(thisVal)
            .trigger("change");
        });
      });
      $(document).on("woocommerce_update_variation_values", function () {
        $(".variation-radios input").each(function (index, element) {
          var $el = $(element);
          var thisName = $el.attr("name");
          var thisVal = $el.attr("value");
          $el.removeAttr("disabled");
          if (
            $(
              'select[name="' + thisName + '"] option[value="' + thisVal + '"]'
            ).is(":disabled")
          ) {
            $el.prop("disabled", true);
          }
        });
      });
    },

    sizeTable: function () {
      $("a.size-trigger, .table-image .close").click(function (e) {
        e.preventDefault();
        $(".table-image").toggleClass("visible");
      });
    },

    ajaxSearch: function () {
      $("#search-field").on("input", function () {
        var search_query = $(this).val();
        if (search_query.length > 2) {
          $.ajax({
            url: ajaxurl,
            type: "GET",
            dataType: "json",
            data: {
              action: "custom_search",
              search_query: search_query,
            },
            success: function (response) {
              var suggestions_html = "";
              $.each(response, function (index, value) {
                suggestions_html += '<div class="suggestion">';
                suggestions_html += '<a href="' + value.permalink + '">';
                suggestions_html +=
                  '<img src="' + value.image + '" alt="' + value.title + '">';
                suggestions_html += '<div class="title-wrap">';
                suggestions_html +=
                  '<span class="title">' + value.title + "</span>";
                suggestions_html +=
                  '<span class="price">' + value.price + "</span>";
                suggestions_html += "</div>";
                suggestions_html += "</a>";
                suggestions_html += "</div>";
              });
              $("#suggestions-container").html(suggestions_html);
            },
          });
        } else {
          $("#suggestions-container").html("");
        }
      });

      $("#search-field").on("blur", function () {
        setTimeout(function () {
          if (!$("#suggestions-container").is(":hover")) {
            $("#suggestions-container").html("");
            $("#search-field").val("");
          }
        }, 100);
      });

      $("#suggestions-container").on("mouseenter", function () {
        clearTimeout(timeoutId);
      });

      $("#suggestions-container").on("mouseleave", function () {
        timeoutId = setTimeout(function () {
          $("#suggestions-container").html("");
          $("#search-field").val("");
        }, 100);
      });
    },

    addToCartAjax: function () {
      $(document).on(
        "added_to_cart",
        function (event, fragments, cart_hash, $button) {
          var productId, quantity;
          if ($button.is("button")) {
            productId = $button.val();
            quantity = $button.siblings(".quantity").find('input[name="quantity"]').val();
          } else if ($button.is("a")) {
            productId = $button.data('product_id');
            quantity = $button.data('quantity');
          }

          $.ajax({
            url: wc_add_to_cart_params.ajax_url,
            type: "POST",
            data: {
              action: "get_product_details",
              product_id: productId,
              quantity: quantity,
            },
            success: function (response) {
              $("#product-details").html(response);
              $("#cart-overlay").addClass("opened");
              $("body").addClass("fixed");
              setTimeout(function(){
                $("#cart-overlay").removeClass("opened");
                $("body").removeClass("fixed");
            }, 5000);
            },
            error: function (jqXHR, textStatus, errorThrown) {
              console.log("Błąd pobierania danych produktu:");
              console.log("Status: " + textStatus);
              console.log("Error: " + errorThrown);
              console.log("Response: " + jqXHR.responseText);
            },
          });

          $("#cart-overlay .close").on("click", function (e) {
            e.preventDefault();
            $("#cart-overlay").removeClass("opened");
            $("body").removeClass("fixed");
          });

          $("#cart-overlay").on("click", function (e) {
            if (e.target === this) {
              $("#cart-overlay").removeClass("opened");
              $("body").removeClass("fixed");
            }
          });

          document.body.addEventListener("keyup", (ev) => {
            if (ev.key === "Escape") {
              $("#cart-overlay").removeClass("opened");
              $("body").removeClass("fixed");
            }
          });
        }
      );
    },

    productsFunctions: function () {
      $(".woocommerce ul.products li").click(function (event) {
        if (!$(event.target).is(".tinv-wishlist a, a.added_to_cart.wc-forward, .add_to_cart_button")) {
          window.location = $(this)
            .find("a.woocommerce-loop-product__link")
            .attr("href");
          return false;
        }
      });

      $("li.wc-block-grid__product").click(function (event) {
        if (!$(event.target).is(".tinv-wishlist a, a.added_to_cart.wc-forward, .add_to_cart_button")) {
          window.location = $(this)
            .find("a.wc-block-grid__product-link")
            .attr("href");
          return false;
        }
      });

      $("li.wc-block-grid__product").each(function () {
        var tinv = $(this).find(".tinv-wraper");
        var thumb = $(this).find(".wc-block-grid__product-link");
        var title = $(this).find(".wc-block-grid__product-title");
        $(title).insertAfter(thumb);
        $(tinv).insertAfter(thumb);
      });
    },

    infiniteScroll: function() {
      let page = 2;
      let loading = false;
      const productContainer = $('#product-list');
      const category = productContainer.data('category'); 
      
      $(window).scroll(function() {
          if ($('body').hasClass('archive') && $(window).scrollTop() + $(window).height() >= $(document).height() - 500 && !loading) {
              loading = true;
              $.ajax({
                  url: ajaxurl,
                  type: 'GET',
                  data: {
                      action: 'load_more_products',
                      page: page,
                      category: category
                  },
                  success: function(response) {
                      if (response) {
                          productContainer.append(response);
                          page++;
                          loading = false;
                      }
                  }
              });
          }
      });
  },
  };
})(jQuery);
